import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument } from "../SharedContentFetchStrategy";

export class AttachmentRequestFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.ATTACHMENT_REQUEST;
  }

  fetch(partnerId: string, refId: string): Promise<SharedContentDocument> {
    // TODO: Implement when attachmentService is available
    return Promise.resolve({
      refId,
      refType: ResourceEnum.ATTACHMENT_REQUEST,
      refDocument: null
    });
  }
}
